import { WifiOutline } from 'react-ionicons';
import { formatCurrency } from 'shared/util/formatCurrency';

interface DetailsSummaryProps {
  recommendation?: string;
  provider?: string;
  term: string;
  ipType: string;
  price: string;
  isSimpleFlow?: boolean;
}

const DetailsSummary = ({
  recommendation,
  term,
  ipType,
  price,
  isSimpleFlow = true,
  provider,
}: DetailsSummaryProps) => {
  return (
    <div className="text-gray-300 flex items-center justify-between gap-4 rounded-lg text-xs font-bold">
      <div className="flex gap-4 pl-3">
        {recommendation && (
          <div className="flex items-center">
            <span className="mr-2">
              <TrophyLightIcon />
            </span>
            <span>{recommendation}</span>
          </div>
        )}
        {provider && (
          <div className="flex items-center">
            <span className="mr-2">
              <WifiOutline color="#94A3B8" width="18px" height="18px" />
            </span>
            <span>{provider}</span>
          </div>
        )}
        {!isSimpleFlow && (
          <>
            <div className="flex items-center">
              <span className="mr-2">
                <TextDocumentIcon />
              </span>
              <span>{term}</span>
            </div>
            <div className="flex items-center">
              <span className="mr-2">
                <LocationIcon />
              </span>
              <span>{ipType}</span>
            </div>
          </>
        )}
      </div>
      <div className="pr-3 text-content-base-default">
        <span>{formatCurrency(+price)}</span>
      </div>
    </div>
  );
};

export default DetailsSummary;

const TrophyLightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9333 1.125L12.9326 1.125L5.06567 1.13414L5.06501 1.13414L5.06527 1.13414C4.76765 1.13424 4.48219 1.25228 4.27141 1.4624C4.06053 1.67262 3.9416 1.95787 3.94067 2.25562L3.94066 2.25738C3.94066 2.40265 3.94058 2.59162 3.94043 2.8125H1.6875C1.37684 2.8125 1.125 3.06434 1.125 3.375V3.9375C1.125 5.01323 1.44954 6.10824 2.01466 6.94824C2.4823 7.64333 3.1521 8.21111 3.97649 8.38358C4.16027 9.53409 4.94595 10.4812 5.81583 11.1397C6.62303 11.7507 7.59362 12.1842 8.4375 12.3254V15.75H6.1875C5.87684 15.75 5.625 16.0018 5.625 16.3125C5.625 16.6232 5.87684 16.875 6.1875 16.875H9H11.8125C12.1232 16.875 12.375 16.6232 12.375 16.3125C12.375 16.0018 12.1232 15.75 11.8125 15.75H9.5625V12.3249C10.4058 12.1832 11.3754 11.7501 12.182 11.1397C13.0521 10.4814 13.8381 9.53435 14.022 8.38389C14.8471 8.21179 15.5174 7.64374 15.9853 6.94824C16.5505 6.10824 16.875 5.01323 16.875 3.9375V3.375C16.875 3.06434 16.6232 2.8125 16.3125 2.8125H14.059C14.0588 2.58225 14.0585 2.39046 14.0583 2.24978C14.0582 1.95149 13.9397 1.66543 13.7288 1.4545C13.5178 1.24353 13.2316 1.125 12.9333 1.125ZM14.0583 2.24978V2.25L14.0583 2.24911L14.0583 2.24978ZM14.0602 3.9375C14.0612 4.94431 14.0621 6.17269 14.0624 7.19694C14.4238 7.04599 14.7632 6.74938 15.0519 6.32026C15.4848 5.67684 15.75 4.8031 15.75 3.9375H14.0602ZM2.25 3.9375H3.93949C3.93915 4.29751 3.93876 4.68055 3.93838 5.06371L3.93838 5.06429V5.06457L3.93838 5.0651L3.93838 5.0671C3.9376 5.83949 3.93682 6.61206 3.9364 7.19644C3.57546 7.04533 3.23646 6.7489 2.94808 6.32026C2.51521 5.67684 2.25 4.8031 2.25 3.9375ZM5.0625 7.875C5.0625 7.8869 5.06213 7.89871 5.0614 7.91042C5.07658 8.77655 5.64683 9.60079 6.49483 10.2427C7.35561 10.8943 8.36428 11.25 8.99859 11.25C9.63294 11.25 10.642 10.8943 11.5031 10.2426C12.3631 9.59193 12.9375 8.75395 12.9375 7.875C12.9375 6.09501 12.9347 3.14253 12.9333 2.25089L12.9333 2.25L5.06632 2.25914L5.06566 2.25914C5.06566 2.79749 5.06452 3.93106 5.06338 5.06453L5.06338 5.06623C5.06226 6.1744 5.06115 7.2822 5.06109 7.83492C5.06203 7.84816 5.0625 7.86153 5.0625 7.875Z"
      fill="#94A3B8"
    />
  </svg>
);

const TextDocumentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3293 1.20901C5.49513 1.10652 5.70221 1.0972 5.87658 1.18439L6.75002 1.62111L7.62346 1.18439C7.78196 1.10514 7.96852 1.10521 8.12696 1.18457L8.99959 1.62171L9.88667 1.18324C10.0453 1.10484 10.2315 1.10563 10.3894 1.18537L11.2504 1.62007L12.1148 1.18505C12.2735 1.10514 12.4607 1.10498 12.6196 1.18461L13.4915 1.62152L14.3752 1.18351C14.5332 1.1052 14.7188 1.10551 14.8765 1.18435L15.7503 1.62111L16.6234 1.18442C16.7978 1.09721 17.0049 1.1065 17.1707 1.20899C17.3366 1.31148 17.4375 1.49254 17.4375 1.6875V13.5C17.4375 14.3951 17.0819 15.2536 16.449 15.8865C15.8161 16.5194 14.9576 16.875 14.0625 16.875H3.93752C3.23556 16.875 2.64438 16.7605 2.15874 16.5162C1.66413 16.2674 1.31209 15.9004 1.07094 15.4556C0.612205 14.6094 0.562584 13.4832 0.562522 12.3771C0.561596 12.2293 0.589919 12.0828 0.645871 11.946C0.702189 11.8083 0.785372 11.6832 0.890563 11.578C0.995754 11.4729 1.12084 11.3897 1.25853 11.3333C1.3953 11.2774 1.54178 11.2491 1.68952 11.25H5.06252V1.6875C5.06252 1.49255 5.16346 1.3115 5.3293 1.20901ZM6.18752 11.25H11.25C11.5607 11.25 11.8125 11.5018 11.8125 11.8125V13.5C11.8125 14.0967 12.0496 14.669 12.4715 15.091C12.8935 15.5129 13.4658 15.75 14.0625 15.75C14.6593 15.75 15.2316 15.5129 15.6535 15.091C16.0755 14.669 16.3125 14.0967 16.3125 13.5V2.59777L16.002 2.75308C15.8436 2.83228 15.6572 2.83231 15.4989 2.75315L14.624 2.31583L13.74 2.75399C13.5818 2.83239 13.396 2.83198 13.2382 2.7529L12.3682 2.31695L11.5029 2.75245C11.3436 2.83263 11.1557 2.83251 10.9965 2.75213L10.1333 2.31628L9.24716 2.75426C9.08912 2.83238 8.9036 2.83189 8.74598 2.75293L7.87479 2.31651L7.00158 2.75312C6.84322 2.8323 6.65682 2.8323 6.49846 2.75312L6.18752 2.59764V11.25ZM11.5469 15.75C10.995 15.1329 10.6875 14.3323 10.6875 13.5V12.375H1.68752C1.68752 13.5182 1.7566 14.3599 2.05995 14.9194C2.19998 15.1777 2.39009 15.3732 2.66428 15.5112C2.94744 15.6536 3.35171 15.75 3.93752 15.75H11.5469ZM7.31252 5.0625C7.31252 4.75184 7.56436 4.5 7.87502 4.5H14.625C14.9357 4.5 15.1875 4.75184 15.1875 5.0625C15.1875 5.37316 14.9357 5.625 14.625 5.625H7.87502C7.56436 5.625 7.31252 5.37316 7.31252 5.0625ZM9.56252 7.875C9.56252 7.56434 9.81436 7.3125 10.125 7.3125H14.625C14.9357 7.3125 15.1875 7.56434 15.1875 7.875C15.1875 8.18566 14.9357 8.4375 14.625 8.4375H10.125C9.81436 8.4375 9.56252 8.18566 9.56252 7.875Z"
      fill="#94A3B8"
    />
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.375 6.50391C3.375 3.50906 5.92109 1.125 9 1.125C12.0789 1.125 14.625 3.50906 14.625 6.50391C14.625 8.19227 13.7121 10.2811 12.7122 12.0867C11.6972 13.9192 10.5283 15.5703 9.90146 16.4168C9.79803 16.5582 9.66278 16.6733 9.50663 16.7528C9.34969 16.8326 9.17609 16.8743 9 16.8743C8.82391 16.8743 8.65031 16.8326 8.49337 16.7528C8.3372 16.6733 8.20194 16.5582 8.0985 16.4168C7.47168 15.5699 6.30279 13.9182 5.28782 12.0854C4.28789 10.2798 3.375 8.19107 3.375 6.50391ZM9 2.25C6.48907 2.25 4.5 4.18242 4.5 6.50391C4.5 7.87534 5.27461 9.73939 6.27199 11.5404C7.25166 13.3095 8.38638 14.9145 9 15.7437C9.6136 14.9149 10.7483 13.3104 11.728 11.5416C12.7254 9.74087 13.5 7.8766 13.5 6.50391C13.5 4.18242 11.5109 2.25 9 2.25Z"
      fill="#94A3B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 5.625C8.37868 5.625 7.875 6.12868 7.875 6.75C7.875 7.37132 8.37868 7.875 9 7.875C9.62132 7.875 10.125 7.37132 10.125 6.75C10.125 6.12868 9.62132 5.625 9 5.625ZM6.75 6.75C6.75 5.50736 7.75736 4.5 9 4.5C10.2426 4.5 11.25 5.50736 11.25 6.75C11.25 7.99264 10.2426 9 9 9C7.75736 9 6.75 7.99264 6.75 6.75Z"
      fill="#94A3B8"
    />
  </svg>
);
